module.exports = __webpack_public_path__ + "img/center-card-bg.e0b7335b.png";